import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { useAuth } from 'src/libs/rainbow';
import { userKeys } from './user-keys';
import { QueryOptions } from 'src/libs/react-query';

export interface GetWithdrawalAmountTradeResponse {
  availableAmount: number;
  pendingWithdrawals: {
    id: number;
    tokenID: string;
    amount: number;
    chainID: number;
    availableAt: string;
  }[];
  amount: number;
  availableAt: string;
  chainID: number;
  id: number;
  tokenID: string;
}

export interface GetWithdrawalAmountTradeParams {
  tokenID: string;
  chainID: number;
}

export const getWithdrawalAmountTrade = async (params: GetWithdrawalAmountTradeParams) => {
  const response = await apiClient.get<any>(`/api/v2/signatures/balances/withdrawable`, {
    params: {
      tokenID: params.tokenID,
      chainID: params.chainID,
    },
    baseURL: process.env.REACT_APP_SIGNATURE_SERVICE_API_ENDPOINT,
  });

  return response.data;
};

export type UseGetWithdrawalAmountTradeOptions<TError, TContext> = QueryOptions<
  GetWithdrawalAmountTradeResponse,
  TError,
  GetWithdrawalAmountTradeResponse,
  ReturnType<typeof userKeys.allGetWithdrawalAmountTrade>
>;

export const useGetWithdrawalAmountTrade = <TError = Error, TContext = unknown>(
  params: GetWithdrawalAmountTradeParams,
  options?: UseGetWithdrawalAmountTradeOptions<TError, TContext>,
) => {
  const { isAuthenticated, isEthereumWallet } = useAuth();
  return useQuery({
    queryKey: userKeys.allGetWithdrawalAmountTrade(params),
    queryFn: () => getWithdrawalAmountTrade(params),
    enabled: isAuthenticated && isEthereumWallet,
    ...options,
  });
};
